$(document).ready(function() {

    var dataSetSelectOption = [{
            "id": "1269076",
            "name": "【エアコンオプション】ドレンホース防虫キャップ",
            "part": "エアコン",
            "select": "check"
        },
        {
            "id": "1269077",
            "name": "【エアコンオプション】エアコン室外機 (室内機とセット)",
            "part": "エアコン",
            "select": ""
        },
        {
            "id": "1269078",
            "name": "【エアコンオプション】エコ洗浄",
            "part": "エアコン",
            "select": ""
        },
        {
            "id": "1269079",
            "name": "【エアコンオプション】防カビチタンコーティング",
            "part": "エアコン",
            "select": ""
        }
    ];

    $('#select_option_table').DataTable({
        searching: false,
        info: false,
        paging: false,
        order: false,
        data: dataSetSelectOption,
        columns: [{
                data: 'id',
                orderable: false
            },
            {
                data: 'name',
                orderable: false
            },
            {
                data: 'part',
                orderable: false
            },
            {
                data: 'select',
                orderable: false,
                render: function(data, type, full) {
                    if (full.select == 'check') {
                        data = '<i class="fa fa-check-square"></i>'
                    }else{
                        data = '<i class="fa fa-square"></i>'
                    }
                    return data;
                }
            }
        ]
    });

    // order-service-table
    var dataSet = [
        {'column1': 'エアコン壁掛け（スタンダード）', 'column2': '11,000円', 'column3': '1個', 'column4': '11,800円', 'column5': '5,000円', 'column6': '0円', 'column7': true, 'column8': '6,800円'},
        {'column1': 'キッチン換気扇レンジフードナチュラル', 'column2': '13,500円', 'column3': '1個', 'column4': '14,580円', 'column5': '0円', 'column6': '0円', 'column7': true, 'column8': '14,580円'},
        {'column1': '水まわり浴室クリーニングナチュラル', 'column2': '13,500円', 'column3': '1個', 'column4': '14,580円', 'column5': '0円', 'column6': '0円', 'column7': true, 'column8': '14,580円'}
    ];

    $('#order_service_table').DataTable({
        searching: false,
        info: false,
        paging: false,
        order: false,
        data: dataSet,
        columns: [
            { data: 'column1', orderable: false },
            { data: 'column2', orderable: false },
            { data: 'column3', orderable: false },
            { data: 'column4', orderable: false },
            { data: 'column5', orderable: false },
            { data: 'column6', orderable: false },
            {
                data: 'column7',
                orderable: false,
                render: function(data, type, full) {
                    if (full.column7 === true) {
                        data = '<a href="javascript:void(0);" data-toggle="modal" data-target="#modal_calculator"><i class="fa fa-money"></i></a>';
                    }

                    return data;
                }
            },
            { data: 'column8', orderable: false },
            {
                data: 'column1',
                orderable: false,
                render: function(data, type) {
                    if (type === 'display') {
                        data = '<a href="#"><i class="fa fa-minus-circle"></i></a>';
                    }

                    return data;
                }
            },
            {
                data: 'column1',
                orderable: false,
                render: function(data, type) {
                    if (type === 'display') {
                        data = '<a href="#"><i class="fa fa-plus-circle"></i></a>';
                    }

                    return data;
                }
            },
            {
                data: 'column1',
                orderable: false,
                render: function(data, type) {
                    if (type === 'display') {
                        data = '<a href="#"><i class="fa fa-trash-o"></i></a>';
                    }

                    return data;
                }
            }
        ]
    });

    // project-table
    var dataSetProject = [{
            "project": "エアコン壁掛け（スタンダード）",
            "quantity": "1個",
            "amount": "11,800円",
            "discount_amount": "5,000円"
        },
        {
            "project": "キッチン換気扇レンジフードナチュラル",
            "quantity": "1個",
            "amount": "14,580円",
            "discount_amount": "0円"
        },
        {
            "project": "水まわり浴室クリーニングナチュラル",
            "quantity": "1個",
            "amount": "14,580円",
            "discount_amount": "0円"
        },
    ];

    $('#project_table').DataTable({
        searching: false,
        info: false,
        paging: false,
        order: false,
        data: dataSetProject,
        columns: [{
                data: 'project',
                orderable: false
            },
            {
                data: 'quantity',
                orderable: false
            },
            {
                data: 'amount',
                orderable: false
            },
            {
                data: 'discount_amount',
                orderable: false
            }
        ]
    });

    $('#project_table_confirmed').DataTable({
        searching: false,
        info: false,
        paging: false,
        order: false,
        data: dataSetProject,
        columns: [{
                data: 'project',
                orderable: false
            },
            {
                data: 'quantity',
                orderable: false
            }
        ]
    });

    $('#project_table_finish').DataTable({
        searching: false,
        info: false,
        paging: false,
        order: false,
        data: dataSetProject,
        columns: [{
                data: 'project',
                orderable: false
            },
            {
                data: 'quantity',
                orderable: false
            },
            {
                data: 'amount',
                orderable: false
            },
            {
                data: 'discount_amount',
                orderable: false
            }
        ]
    });

    $('#project_table_complete').DataTable({
        searching: false,
        info: false,
        paging: false,
        order: false,
        data: dataSetProject,
        columns: [{
                data: 'project',
                orderable: false
            },
            {
                data: 'quantity',
                orderable: false
            }
        ]
    });

    // change-service-table
    var dataSetChangeService = [{
            "project": "エアコン壁掛け（スタンダード）",
            "quantity": "1個",
            "reduction": "",
            "add": "",
            "delete": ""
        },
        {
            "project": "キッチン換気扇レンジフードナチュラル",
            "quantity": "1個",
            "reduction": "",
            "add": "",
            "delete": ""
        },
        {
            "project": "水まわり浴室クリーニングナチュラル",
            "quantity": "1個",
            "reduction": "",
            "add": "",
            "delete": ""
        }
    ];

    $('#change_service_table').DataTable({
        searching: false,
        info: false,
        paging: false,
        order: false,
        data: dataSetChangeService,
        columns: [{
                data: 'project',
                orderable: false
            },
            {
                data: 'quantity',
                orderable: false
            },
            {
                data: 'reduction',
                orderable: false,
                render: function(data, type) {
                    if (type === 'display') {
                        data = '<a href="javascript:void(0);" data-toggle="modal" data-target="#change_service"><i class="fa fa-minus-circle"></i></a>';
                    }
                    return data;
                }
            },
            {
                data: 'add',
                orderable: false,
                render: function(data, type) {
                    if (type === 'display') {
                        data = '<a href="javascript:void(0);" data-toggle="modal" data-target="#change_service"><i class="fa fa-plus-circle"></i></a>';
                    }
                    return data;
                }
            },
            {
                data: 'delete',
                orderable: false,
                render: function(data, type) {
                    if (type === 'display') {
                        data = '<a href="javascript:void(0);" data-toggle="modal" data-target="#change_service"><i class="fa fa-trash"></i></a>';
                    }
                    return data;
                }
            },
        ]
    });

    var dataSetUpdateService = [{
            "project": "エアコン壁掛け（スタンダード）",
            "quantity": "1個",
            "reason": "サービス商品の個数削除",
        },
        {
            "project": "エアコン壁掛け（スタンダード）",
            "quantity": "1個",
            "reason": "サービス商品の個数追加",
        },
        {
            "project": "エアコン壁掛け（スタンダード）",
            "quantity": "1個",
            "reason": "サービス商品の追加",
        },
        {
            "project": "エアコン壁掛け（スタンダード）",
            "quantity": "1個",
            "reason": "サービス商品の削除",
        }
    ];

    $('#new_update_service_table').DataTable({
        searching: false,
        info: false,
        paging: false,
        order: false,
        data: dataSetUpdateService,
        columns: [{
                data: 'project',
                orderable: false
            },
            {
                data: 'quantity',
                orderable: false
            },
            {
                data: 'reason',
                orderable: false
            }
        ]
    });

    var dataChangeService = [{
            "project": "エアコン壁掛け（スタンダード）",
            "quantity": "1個",
            "reason": "設備不良の為削除"
        }
    ];

    $('#change_service_complete_table').DataTable({
        searching: false,
        info: false,
        paging: false,
        order: false,
        data: dataChangeService,
        columns: [{
                data: 'project',
                orderable: false
            },
            {
                data: 'quantity',
                orderable: false
            },
            {
                data: 'reason',
                orderable: false
            }
        ]
    });

    $('#submit_survey').on('click', function() {
        $('#survey').modal('hide')
        $('#confirm_signature').modal('show')
    })

    $('#btn_confirm_after_work').on('click', function(){
        $('#survey').modal('show')
        $('#confirm_after_work').modal('hide')
    })

    $('#select_label').on('click', function() {
        $('#change_service').modal('show')
        $('#modal_select_service').modal('hide')
    })

});

$(document).on('click', 'input[type=checkbox]', function(event) {
    if($(this).is(':checked')){
        $(this).attr('checked', 'checked');
    } else {
        $(this).removeAttr('checked');
    }
});

$(document).on('click','td', function(e){
    $(this).find('input[type=radio]').prop('checked', true);
    let cb = $(e.target).children(":checkbox");
    cb.attr("checked", !cb.attr("checked"));
});